const BlogPageHeading = ({ title }: { title: string }) => (
  <div className="h-40 bg-cover bg-right bg-no-repeat bg-template-page-cover">
    <div className="container mx-auto flex h-full items-center justify-start">
      <h1 className="hidden text-3xl text-white font-semibold md:block">{title}</h1>
    </div>
  </div>
);

export default BlogPageHeading;
